import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create Overtime Pay
export const createOvertimePay = createAsyncThunk(
  'overtimePay/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post('/overtimepay', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create overtime pay');
    }
  }
);

// Fetch All Overtime Pays
export const fetchOvertimePays = createAsyncThunk(
  'overtimePay/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get('/overtimepay');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch overtime pays');
    }
  }
);

// Fetch Overtime Pay by ID
export const fetchOvertimePayById = createAsyncThunk(
  'overtimePay/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/overtimepay/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch overtime pay');
    }
  }
);

// Update Overtime Pay
export const updateOvertimePay = createAsyncThunk(
  'overtimePay/update',
  async ({ id, ...data }: any & { id: number }, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.put(`/overtimepay/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update overtime pay');
    }
  }
);

// Delete Overtime Pay
export const deleteOvertimePay = createAsyncThunk(
  'overtimePay/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.delete(`/overtimepay/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete overtime pay');
    }
  }
);
